module.exports = __webpack_public_path__ + "img/towerBanners.91d4ca59.jpg";